import * as React from "react";
import auth from "../../Auth";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import ColumnMenu from "../../Shared/GridComponents/ColumnMenu";
import { CellRender, GridNoRecord, StatusCell } from "../../Shared/GridComponents/CommonComponents";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { State } from "@progress/kendo-data-query";
import { DetailColumnCell, ViewMoreComponent, ReqNumberCell } from "./GlobalActions";
import { CreateQueryString, updatedCreateQueryString } from "../../ReusableComponents";
import "../../../assets/css/App.css";
import "../../../assets/css/KendoCustom.css";
import CompleteSearch from "../../Shared/Search/CompleteSearch";
import { applySettingFilters, datetimeFormatter, downloadExcel, getClientSettingsData, initialDataState, successToastr } from "../../../HelperMethods";
import BreadCrumbs from "../../Shared/BreadCrumbs/BreadCrumbs";
import { EXCEL_DOWNLOAD_INPROGRESS } from "../../Shared/AppMessages";
import reportServices from "../../Shared/Services/ReportServices";
import { storeFilters } from "../../Shared/PersistFilteredData";
import { GridDataState, LocalizationResource, SETTINGS, SettingCategory } from "../../Shared/AppConstants";
import { LocalizationHelper } from "../../../Localization/helpers/LocalizationHelper";

export interface RequisitionFunnelReportProps { }

export interface RequisitionFunnelReportState {
    searchString: string;
    data: any;
    allData?: any;
    clientId?: string;
    vendorId?: string;
    dataState: any;
    showRemoveModal?: boolean;
    showCopyModal?: boolean;
    showLoader?: boolean;
    totalCount?: number;
    showHoldPositionModal?: any;
    showReqHistoryModal?: any;
    onFirstLoad: boolean;
    displayEntityNumber: boolean;
}

class RequisitionFunnelReport extends React.Component<RequisitionFunnelReportProps, RequisitionFunnelReportState> {
    public reqId: string;
    public dataItem: any;
    public openModal: any;
    constructor(props: RequisitionFunnelReportProps) {
        super(props);
        this.state = {
            searchString: "",
            data: [],
            dataState: initialDataState,
            clientId: auth.getClient(),
            vendorId: auth.getVendor(),
            onFirstLoad: true,
            showLoader: true,
            displayEntityNumber: false
        };
    }
    componentDidMount() {

        this.getClientSetting(this.state.clientId);
    }

    getClientSetting = (id) => {
        getClientSettingsData(id).then((res) => {
            applySettingFilters(res, SettingCategory.REQUISITION, SETTINGS.DISPLAY_ENTITY_NUMBER, (response) => {
                this.setState({ displayEntityNumber: response });
            });
        });
    };
    getRequisitionFunnelReport = (dataState?, isAdvanceSearch?) => {
        dataState = { sort: [{ field: "startDate", dir: "desc" }], ...dataState };
        if (isAdvanceSearch) {
            this.state.dataState.skip = 0;
        }
        this.setState({ showLoader: true, onFirstLoad: false, dataState: this.state.dataState });
        let finalQueryString = updatedCreateQueryString(dataState, this.state.clientId, this.state.vendorId);
        axios.get(`api/report/requisitionfunnel?${`$count=true&`}${finalQueryString}`).then((res) => {
            this.setState({
                data: res.data.items,
                showLoader: false,
                dataState: dataState,
                totalCount: res.data.count
            });
        });
    };

    expandChange = (dataItem) => {
        const { data } = this.state;
        const rptData = data.map((item) => {
            if (item === dataItem) {
                item.expanded = !item.expanded;
            }
            return item;
        });
        this.setState({
            data: rptData
        });
    };

    onDataStateChange = (changeEvent) => {
        storeFilters(GridDataState.REPORTREQUISITIONFUNNEL, changeEvent.dataState);
        this.getRequisitionFunnelReport(changeEvent.dataState);
    };

    ExpandCell = (props) => <DetailColumnCell {...props} expandChange={this.expandChange.bind(this)} />;

    render() {
        return (
            <div className="col-11 mx-auto pl-0 pr-0 mt-3  mt-md-0">
                <div className="container-fluid mt-3 mb-3 d-md-block d-block">
                    <div className="row pt-1 pb-1 mt-3 accordianTitleClr mx-auto mb-2">
                        <div className="col-12 fonFifteen paddingLeftandRight d-flex justify-content-between align-items-center">
                            <BreadCrumbs></BreadCrumbs>
                            <span title="Export to Excel" onClick={() => this.downloadRequisitionFunnelReportExcel(this.state.data)} className="mr-2 float-right text-dark shadow invoice cursor-pointer">
                                <FontAwesomeIcon icon={faFileExcel} style={{ color: "white" }} className={"faclock_size d-block"}></FontAwesomeIcon>
                            </span>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <CompleteSearch
                        placeholder="Search text here!"
                        handleSearch={this.getRequisitionFunnelReport}
                        entityType={"RequisitionFunnelReport"}
                        onFirstLoad={this.state.onFirstLoad}
                        page="RequisitionFunnelReport"
                        persistSearchData={true}
                    />
                    <div className="myOrderContainer global-action-grid table_responsive-TABcandidates frozen-column" id="grouping-performance-grid">
                        <Grid
                            style={{ height: "auto" }}
                            sortable={true}
                            onDataStateChange={this.onDataStateChange}
                            pageable={{ pageSizes: true }}
                            data={this.state.data}
                            {...this.state.dataState}
                            detail={ViewMoreComponent}
                            expandField="expanded"
                            total={this.state.totalCount}
                            className="kendo-grid-custom k-widget lastchild report-grid"
                        >
                            <GridNoRecords>{GridNoRecord(this.state.showLoader)}</GridNoRecords>
                            <GridColumn field="reqNumber" width={150} title="Req#" cell={ReqNumberCell} columnMenu={ColumnMenu} />
                            <GridColumn
                                field="region"
                                title="Region"
                                width={150}
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Region")}
                                filter="text"
                            />
                            <GridColumn
                                field="division"
                                title="Division"
                                width={150}
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Division")}
                                filter="text"
                            />
                            <GridColumn
                                field="location"
                                title={LocalizationHelper.getLocalizedTitle(LocalizationResource.Location_Label, "Location")}
                                width={150}
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Location")}
                            />
                            <GridColumn
                                field="position"
                                title="Position"
                                width={150}
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Position")}
                            />
                            <GridColumn
                                field="releasedDate"
                                filter="date"
                                format="{0:d}"
                                editor="date"
                                width={195}
                                title="Requisition Release Date"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Requisition Release Date", null, true)}
                            />
                            <GridColumn
                                field="startDate"
                                filter="date"
                                format="{0:d}"
                                editor="date"
                                width={140}
                                title="Start Date"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Start Date")}
                            />
                            <GridColumn
                                field="endDate"
                                filter="date"
                                format="{0:d}"
                                editor="date"
                                width={140}
                                title="End Date"
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "End Date")}
                            />
                            <GridColumn
                                field="associatesRequired"
                                title="Required Positions"
                                headerClassName="text-right pr-4"
                                columnMenu={ColumnMenu}
                                width={140}
                                filter={"numeric"}
                                cell={(props) =>
                                    props.dataItem.associatesRequired !== undefined &&
                                        props.dataItem.associatesRequired !== null ? (
                                        <td
                                            className="text-right pr-4"
                                            contextMenu={"Required Positions"}
                                        >
                                            {Number(props.dataItem.associatesRequired)}
                                        </td>
                                    ) : (
                                        <td style={{ textAlign: "right" }}>{"-"}</td>
                                    )
                                }
                            />
                            <GridColumn
                                field="totalAssociatesSubmitted"
                                title="Submitted Candidates"
                                headerClassName="text-right pr-4"
                                columnMenu={ColumnMenu}
                                width={180}
                                filter={"numeric"}
                                cell={(props) =>
                                    props.dataItem.totalAssociatesSubmitted !== undefined &&
                                        props.dataItem.totalAssociatesSubmitted !== null ? (
                                        <td
                                            className="text-right pr-4"
                                            contextMenu={"Submitted Candidates"}
                                        >
                                            {Number(props.dataItem.totalAssociatesSubmitted)}
                                        </td>
                                    ) : (
                                        <td style={{ textAlign: "right" }}>{"-"}</td>
                                    )
                                }
                            />
                            <GridColumn
                                field="totalNameClearSubmission"
                                title="Name Cleared Candidates"
                                headerClassName="text-right pr-4"
                                columnMenu={ColumnMenu}
                                width={200}
                                filter={"numeric"}
                                cell={(props) =>
                                    props.dataItem.totalNameClearSubmission !== undefined &&
                                        props.dataItem.totalNameClearSubmission !== null ? (
                                        <td
                                            className="text-right pr-4"
                                            contextMenu={"Name Cleared Candidates"}
                                        >
                                            {Number(props.dataItem.totalNameClearSubmission)}
                                        </td>
                                    ) : (
                                        <td style={{ textAlign: "right" }}>{"-"}</td>
                                    )
                                }
                            />
                            <GridColumn
                                field="totalAssociatesVendorSubmitted"
                                title="Vendor Presented Candidates"
                                headerClassName="text-right pr-4"
                                columnMenu={ColumnMenu}
                                filter={"numeric"}
                                width={215}
                                cell={(props) =>
                                    props.dataItem.totalAssociatesVendorSubmitted !== undefined &&
                                        props.dataItem.totalAssociatesVendorSubmitted !== null ? (
                                        <td
                                            className="text-right pr-4"
                                            contextMenu={"Vendor Presented Candidates"}
                                        >
                                            {Number(props.dataItem.totalAssociatesVendorSubmitted)}
                                        </td>
                                    ) : (
                                        <td style={{ textAlign: "right" }}>{"-"}</td>
                                    )
                                }
                            />
                           
                            <GridColumn
                                width={90}
                                field="nsCostCenter"
                                title={LocalizationHelper.getLocalizedTitle(LocalizationResource.PO_Label, "PO")}
                                columnMenu={ColumnMenu}
                                cell={(props) => CellRender(props, "Ns Cost Center")}

                            />
                            {this.state.displayEntityNumber && (
                                <GridColumn
                                    width={90}
                                    field="entityNumber"
                                    title="Entity #"
                                    columnMenu={ColumnMenu}
                                    cell={(props) => CellRender(props, "Entity #")}
                                />
                            )}
                            <GridColumn
                                locked={true}
                                field="status"
                                width="220px"
                                title="Status" columnMenu={ColumnMenu} cell={StatusCell} />
                            <GridColumn locked sortable={false} field="expanded" width="80px" title="View More" cell={this.ExpandCell} />
                        </Grid>
                    </div>
                </div>
            </div>
        );
    }

    downloadRequisitionFunnelReportExcel = (data) => {
        if (data.length === 0) {
            return;
        }
        var finalState: State = {
            ...this.state.dataState,
            take: null,
            skip: 0,
        };
        successToastr(EXCEL_DOWNLOAD_INPROGRESS);
        reportServices.getRequisitionFunnelReportExcelForExcel(this.state.clientId, this.state.vendorId, finalState,this.state.displayEntityNumber).then((res: any) => {
            if (res) {
                downloadExcel("Requisition Funnel Report.xlsx", res.data);
            }
        });
    }
}
export default RequisitionFunnelReport;
